var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageDashboard"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_vm._v("\n        บรรจุสินค้า\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }